export const SET_SOCIAL_AUTH = "SET_SOCIAL_AUTH";


export interface SetSocialAuth {
    type: typeof SET_SOCIAL_AUTH;
    socialAuthData: object | any;
}

export type SocialAuthActionsTypes = SetSocialAuth
